import { render, staticRenderFns } from "./ListAnnotationsBy.vue?vue&type=template&id=1886c797&scoped=true"
import script from "./ListAnnotationsBy.vue?vue&type=script&lang=js"
export * from "./ListAnnotationsBy.vue?vue&type=script&lang=js"
import style0 from "./ListAnnotationsBy.vue?vue&type=style&index=0&id=1886c797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886c797",
  null
  
)

export default component.exports